import { Module } from '@api';

type ModuleGroupsById = {
    byId: {
        [key: string]: Array<number>
    }
    allIds: Array<string>
};

export function groupModulesById (modules: Array<Module> = []): ModuleGroupsById {
    const byId: { [id: string]: Array<number> } = {};
    const allIds: string[] = [];

    modules.forEach(module => {
        if (!byId[module.group]) {
            byId[module.group] = [];
            allIds.push(module.group);
        }

        byId[module['group']].push(module.id);
    });

    return {
        byId,
        allIds
    };
}
